/**
 * TanStack Query hooks for `pinterest-conversions-api`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	pinterestConversionsApiQueryKeys,
	type CreatePinterestConversionsApiBody,
	type ListPinterestConversionsApiResponse,
	type PinterestConversionsApiRow,
} from "./api";

export function usePinterestConversionsApiList(): UseQueryResult<ListPinterestConversionsApiResponse, Error> {
	return useQuery({
		queryKey: pinterestConversionsApiQueryKeys.list(),
		queryFn: list,
	});
}

export function usePinterestConversionsApiCreate(): UseMutationResult<PinterestConversionsApiRow, Error, CreatePinterestConversionsApiBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: pinterestConversionsApiQueryKeys.all });
		},
	});
}

export function usePinterestConversionsApiDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: pinterestConversionsApiQueryKeys.all });
		},
	});
}
